import { z } from "zod";

import { CancelMembershipFormValues } from "./types";

export const INITIAL_VALUES_CANCEL_MEMBERSHIP_FORM: CancelMembershipFormValues =
  {
    cancellationReason: undefined,
    isChangeImmediately: false,
    date: undefined,
  };

export const cancelMembershipFormSchema = z
  .object({
    cancellationReason: z
      .object({
        id: z.union([z.string(), z.number()]),
        label: z.string(),
        value: z.custom<number>(),
      })
      .nullable()
      .optional(),
    isChangeImmediately: z.boolean(),
    date: z.date().nullable().optional(),
  })
  .superRefine(({ date, isChangeImmediately, cancellationReason }, ctx) => {
    if (!cancellationReason) {
      ctx.addIssue({
        code: "custom",
        message: "Cancellation Reason is required",
        path: ["cancellationReason"],
      });
    }
    if (!isChangeImmediately && !date) {
      ctx.addIssue({
        code: "custom",
        message: "Cancellation Date is required",
        path: ["date"],
      });
    }
  });
